import _ from 'lodash';
const editorToolTips = {
  init(el, tip) {
    const tipPosition = tip.arg;
    const ellipsis = tip.modifiers.ellipsis;
    const dark = tip.modifiers.dark;
    let toolTip;
    const buildTip = () => {
      // need an override for weird table sorting issues
      // when tips are in a table that is sortable, the tip
      // message behaves oddly (won't show correct tip)
      const override = el.getAttribute('data-tip-override');
      const tipMsg = override || tip.value;
      if (tipMsg.trim() !== '') {
        toolTip = document.createElement('span');
        toolTip.classList.add('editorUi-tip');
        toolTip.innerHTML = `${tipMsg} <div class="editorUi-tooltip-arrow"></div>`;
        const tipContainer = document.getElementById('drzTooltip-container');
        tipContainer.appendChild(toolTip);

        // Make sure we get the correct offsets if trigger is in a relative parent
        const getOffsets = (tipIcon) => {
          const trigger = tipIcon.getBoundingClientRect();
          const top = trigger.top;
          const left = trigger.left;
          return { top: ~~(top), left: ~~(left) };
        };

        const focus = ellipsis ? el.parentNode : el;
        const windowWidth = window.innerWidth;
        const triggerHeight = ~~(el.offsetHeight);
        const triggerWidth = ~~(focus.offsetWidth);
        const triggerOffsetLeft = getOffsets(focus).left;
        const triggerOffsetTop = getOffsets(el).top;
        const toolTipArrow = toolTip.querySelectorAll('.editorUi-tooltip-arrow')[0];
        const toolTipWidth = ~~(toolTip.offsetWidth);
        const toolTipHeight = ~~(toolTip.offsetHeight);

        // Set arrow class here based on position
        if (tipPosition.match(/top/gi)) {
          toolTipArrow.classList.add('editorUi-at');
        } else if (tipPosition.match(/bottom/gi)) {
          toolTipArrow.classList.add('editorUi-ab');
        } else if (tipPosition.match(/right/gi)) {
          toolTipArrow.classList.add('editorUi-ar');
        } else if (tipPosition.match(/left/gi)) {
          toolTipArrow.classList.add('editorUi-al');
        }

        if (dark) {
          const darkColor = '#27282b';
          toolTip.style.backgroundColor = darkColor;
          toolTipArrow.style[`border${_.startCase(tipPosition)}Color`] = darkColor;
        }

        const liveArrowHeight = ~~(toolTipArrow.offsetHeight);
        const liveArrowWidth = ~~(toolTipArrow.offsetWidth);

        // Reminder: If margins are needed on a tip icon, make sure to add it to the
        // DOM read element and not a psuedo class like :before or :after, because that won't
        // be calculated into the tip position. That is a DOM limitation.

        let leftValue;
        let topValue;

        if (tipPosition.match(/top/gi) || tipPosition.match(/bottom/gi)) {
          if (toolTipWidth <= triggerWidth) {
            // if tip is smaller than tip trigger
            leftValue = (triggerOffsetLeft) + ((triggerWidth - toolTipWidth) / 2);
            toolTip.style.left = `${leftValue}px`;
          } else if (toolTipWidth > triggerWidth) {
            leftValue = (triggerOffsetLeft) - ((toolTipWidth - triggerWidth) / 2);
            // if tip will bleed off to the right or left of window
            if ((leftValue + toolTipWidth) >= (windowWidth)) {
              leftValue = triggerOffsetLeft - (toolTipWidth - triggerWidth);
              toolTipArrow.style.left = 'auto';
              toolTipArrow.style.right = `${(triggerWidth / 2) - (liveArrowWidth / 2)}px`;
            } else if (leftValue <= 0) {
              leftValue = triggerOffsetLeft;
              toolTipArrow.style.right = 'auto';
              toolTipArrow.style.left = `${(triggerWidth / 2) - (liveArrowWidth / 2)}px`;
            }
            toolTip.style.left = `${leftValue}px`;
          }
          if (tipPosition.match(/top/gi)) {
            topValue = (triggerOffsetTop - toolTipHeight) - (liveArrowHeight);
            toolTip.style.top = `${topValue}px`;
          } else if (tipPosition.match(/bottom/gi)) {
            topValue = (triggerOffsetTop + triggerHeight) + (liveArrowHeight);
            toolTip.style.top = `${topValue}px`;
          }
        }
        if (tipPosition.match(/right/gi) || tipPosition.match(/left/gi)) {
          if (triggerHeight >= toolTipHeight) {
            topValue = (triggerOffsetTop) + ((triggerHeight - toolTipHeight) / 2);
            toolTip.style.top = `${topValue}px`;
          } else if (triggerHeight < toolTipHeight) {
            topValue = (triggerOffsetTop) - ((toolTipHeight - triggerHeight) / 2);
            toolTip.style.top = `${topValue}px`;
          }
          if (tipPosition.match(/right/gi)) {
            leftValue = (triggerOffsetLeft + triggerWidth) + liveArrowWidth;
            toolTip.style.left = `${leftValue}px`;
          } else if (tipPosition.match(/left/gi)) {
            leftValue = (triggerOffsetLeft) - (toolTipWidth + liveArrowWidth);
            toolTip.style.left = `${leftValue}px`;
          }
          // Vertically center arrows for left/right positioned tips
          const arrowTop = (toolTipHeight / 2) - (liveArrowHeight / 2);
          toolTipArrow.style.top = `${arrowTop}px`;
        }
        toolTip.classList.add('editorUi-active-tip');
      }
    };

    function removeTip() {
      const tipContainer = document.getElementById('drzTooltip-container');
      if (toolTip && !_.isNull(toolTip.parentNode)) {
        tipContainer.innerHTML = '';
      }
    }

    const overflown = (el) => {
      const parent = window.getComputedStyle(el.parentNode, null);
      let parentL = parent.getPropertyValue('padding-left');
      parentL = ~~(parentL.split('px')[0]);
      let parentR = parent.getPropertyValue('padding-right');
      parentR = ~~(parentR.split('px')[0]);
      return ~~(el.offsetWidth) > ~~(el.parentNode.offsetWidth - parentL - parentR);
    };

    const checkTrigger = () => {
      // check if ellipsis option passed
      // and trigger is overflown
      if (ellipsis && overflown(el)) {
        buildTip();
      } else if (!ellipsis) {
        buildTip();
      }
    };

    el.addEventListener('mouseover', checkTrigger, false);
    el.addEventListener('mouseleave', removeTip, false);
    el.addEventListener('click', removeTip, false);
  },
};

export { editorToolTips };



// WEBPACK FOOTER //
// ./src/directives/tooltips.js